import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import useDrive from "../../hooks/useDrive";
import {useEffect} from "react";
import DriveService from "../../services/DriveService";
import {DRIVE_TYPES} from "../../config/appConst";





export default function FileBreadcrumbs() {
    const {CurrentDrive, changeCurrentDrive} = useDrive();

    function handleClick(path) {
        const {driveType} = CurrentDrive;
        DriveService.getFileTree(path, driveType).then((drive) => {
            if (driveType === DRIVE_TYPES.SHARED) {
                changeCurrentDrive({parent:path, drive: {}, sharedDrive: drive, driveType});

            } else {
                changeCurrentDrive({parent:path, drive});

            }

        })
    }
    const load = () => {
        let crumbs = [{text: "home", path: ""}];
        if (CurrentDrive) {
            const {parent, driveType} = CurrentDrive;
            crumbs = driveType === DRIVE_TYPES.SHARED ? [{text: "Shared (Beta)", path: ""}] : crumbs;

            if (parent) {
                const x = parent.split("/");
                let p = "";
                x.forEach(i => {
                    p = p ? p + "/" + i : i;
                    crumbs.push({text: i, path: p});

                })
            };
        }
        return crumbs.map(({text, path}, i) => {
            const isLast = i === crumbs.length - 1;
            return isLast ? (
                <Typography key={i} sx={{fontSize: '18px', color: '#fff', fontWeight: 600}}>{text}</Typography>
            ) : (
                <Link
                    underline="hover"
                    key={i}
                    onClick={() => handleClick(path)}
                    sx={{fontSize: '18px', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', '&:hover': {color: '#e85878'}}}
                >
                    {text}
                </Link>
            );
        })
    }

    return (
        <Stack spacing={2}>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" sx={{color: '#4a5070'}}/>}
                aria-label="breadcrumb"
            >
                {load()}
                {/*{breadcrumbs}*/}
            </Breadcrumbs>

        </Stack>
    );
}
